import * as yup from 'yup';
import { VideoModal } from '@web/components';
import { schema as muxVideoSchema } from './mux_video';

export const component = VideoModal;

export const schema = yup
  .object({
    shown: yup.bool(),
    video: muxVideoSchema,
    component: yup.string(),
  })
  .required()
  .transform(value => ({
    shown: value.shown ?? false,
    video: value?.video?.[0] ?? value.video,
    component: value.component,
  }));
